module.exports = __webpack_public_path__ + "img/logo.0fb3966b.jpg";